var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 644,
    height: 184,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "logo_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 598,
    y: 0,
    width: 46,
    height: 47
  }, /*#__PURE__*/React.createElement("path", {
    d: "M598.29.792h44.904v46.13H598.29V.792z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M643.194 23.857c0 12.75-10.056 23.065-22.462 23.065-6.451 0-12.262-2.795-16.363-7.286-3.771-4.109-6.079-9.658-6.079-15.779 0-12.75 10.056-23.065 22.442-23.065 9.129 0 17.001 5.592 20.505 13.64a23.47 23.47 0 011.957 9.425z",
    fill: "#F05A26"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.498 119.523v59.001h-35.454v-59.001c0-12.422-9.822-22.514-21.954-22.514-12.086 0-21.904 10.092-21.904 22.514v59.001h-35.503v-59.001c0-32.557 25.681-59 57.407-59 31.726 0 57.408 26.443 57.408 59z",
    fill: "#404042"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.28 178.524v-59.001c0-.55.007-1.098.021-1.644-.819-11.656-10.3-20.87-21.892-20.87-12.087 0-21.907 10.092-21.907 22.514v59.001H0v-59.001c0-32.557 25.684-59 57.41-59 15.378 0 29.338 6.214 39.64 16.326 10.3-10.112 24.26-16.327 39.64-16.327 31.724 0 57.408 26.444 57.408 59.001v59.001h-35.456v-59.001c0-12.422-9.82-22.514-21.952-22.514-11.742 0-21.341 9.522-21.882 21.452.006.353.009.707.009 1.062v59.001H79.279z",
    fill: "#F05A26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.052 123.647V64.646h35.456v59.001c0 12.42 9.82 22.512 21.952 22.512 12.089 0 21.906-10.092 21.906-22.512V64.646h35.504v59.001c0 32.557-25.682 59-57.41 59-31.724 0-57.408-26.443-57.408-59zM602.988 178.524h35.503V60.523h-35.503v118.001zM536.139 178.524h-55.757v-36.44h55.757c12.085 0 21.907-10.092 21.907-22.561 0-12.422-9.822-22.514-21.907-22.514h-55.757V60.523h55.757c31.679 0 57.408 26.394 57.408 59 0 32.607-25.729 59.001-57.408 59.001z",
    fill: "#404042"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h644v184H0z"
  })))));
}

export default __webpack_public_path__ + "8b92bfc31ccee992063688f57524bc9c.svg";
export { SvgLogo as ReactComponent };